import { Lang } from './lang';

export interface AnalogsQueryResponse {
  data: string[];
  lang: Lang;
  // TODO no-explicit-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userID: any;
  filter: {
    IBLOCK_ID: number;
    PROPERTY_GENRES: string;
    '!ID': string[];
  };
}
